export default __webpack_public_path__ + "static/media/logo1.d5ed26a4.png";